import { Component, Input, OnInit } from '@angular/core';
import { UsuariosService } from '../../../../_services/usuarios.service';
import { TerceroCargoService } from '../../../../_services/tercero-cargo.service';
import { NavService } from '../../../../_services/_nav.service';

@Component( {
  selector: 'app-widget-usuario-cargo',
  templateUrl: 'widget-usuario-cargo.component.html'
} )

export class WidgetUsuarioCargoComponent implements OnInit {

  datWidget: any = { numerador: 0, denominador: 0 };
  actCargos = false;
  carDatWidget = true;

  constructor( private usuServicio: UsuariosService,
               private navServicio: NavService,
               private terCargoService: TerceroCargoService ) {
  }

  ngOnInit(): void {
    this.cargarWidget();
  }

  cargarWidget( actCargos?: boolean ) {
    this.usuServicio.obtenerWidgetUsuario().subscribe( rta => {
      this.datWidget = rta;
      if ( actCargos ) {
        this.navServicio.setMesage( 2 );
        this.actCargos = false;
      } else {
        this.carDatWidget = false;
      }
    } );
  }

}
